<div class="row">
  <div class="col">
    <select class="form-select form-select-sm" [(ngModel)]="question.assignedToIdentifier"
      (ngModelChange)="onSelect($event)">
      <option value="">Nicht zugewiesen</option>
      <option *ngFor="let mod of this.moderators" [ngValue]="mod.userId">{{mod.userName}}
      </option>
    </select>
  </div>
</div>